import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enMessages from '../../lang/en'
import axios from 'axios'

Vue.use(VueI18n)

function getDataForReplace (value) {
  if (Vue.prototype.$siteLabels && (value in Vue.prototype.$siteLabels)) {
    return Vue.prototype.$siteLabels[value]
  }
  if (value.toLowerCase() === 'map') {
    return 'Course'
  }
  if (value.toLowerCase() === 'maps') {
    return 'Courses'
  }
  return toTitleCase(value)
}

function toTitleCase (phrase) {
  return i18n.t(phrase
    .split(/[_\s+]/)
    .map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
    .join(' ').replace('And', 'and')).replace('Plcs', 'PLCs')
}

function getLabels (phrase) {
  return (phrase.match(/\[.+?\]/g) || []).map(function (str) {
    return str.slice(1, -1)
  })
}

export const i18n = new VueI18n({
  locale: 'en', // set locale
  formatFallbackMessages: true,
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  messages: { en: enMessages }, // set locale messages
  postTranslation: (data, key) => {
    if (data.includes('[MAP] Description') && ('MAP_DESCRIPTION' in Vue.prototype.$siteLabels)) {
      data = data.replaceAll(/\[MAP\] Description/g, Vue.prototype.$siteLabels.MAP_DESCRIPTION)
    }
    if (data.includes('[') && data.includes(']')) {
      const labels = getLabels(data)
      for (let index = 0; index < labels.length; ++index) {
        data = data.replace('[' + labels[index] + ']', getDataForReplace(labels[index]))
      }
    }
    return data
  }
})

// export i18n
const loadedLanguages = ['en'] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  if (['ar', 'iw'].includes(lang)) {
    document.querySelector('html').setAttribute('dir', 'rtl')
  }
  return lang
}

export function loadLanguageAsync (lang) {
  // If the same language
  if (lang === i18n.locale) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  return import('./../../lang/' + lang + '.js').then(
    messages => {
      i18n.setLocaleMessage(lang, Object.assign(enMessages, messages.default))
      loadedLanguages.push(lang)
      return setI18nLanguage(lang)
    }
  )
}
